module.exports = __webpack_public_path__ + "9ead32a98634a1fb6d6e06a98e8c65c1.pdf";